// extracted by mini-css-extract-plugin
export default {"root":"hfRkDZbpLhygxSv1Jaei","rootIsOpened":"tLjJzABbaEZxV498azoa","inner":"SPZnSJ7tSwl9XzusdHN8","closeIcon":"OcxaP_2e1isaSSYhEe3A","footer":"sf0jIyMYY8svyONamuxQ"};